export const githubMethod = {
  authenticationWithGithub: 'auth-with-github',
  linkingWithGithub: 'link-with-github',
  githubCallToAction: 'github-cta',
  loginWithGithub: 'login-with-github',
};



// WEBPACK FOOTER //
// ./src/resources/github/index.js